// Prequalification email

function initializePrequalificationEmail() {
  const $prequalificationEmailForm = $('#prequalification-email-form');

  if ($prequalificationEmailForm) {
    const $clientSubmitButton = $('#prequalification-email-submit');

    const $inputs = $('#prequalification-email-form').find('input');

    $inputs.keydown(function (e) {
      switch (e.key) {
        case 'Enter':
          e.preventDefault();
          processForm();
        default:
          return;
      }
    });

    $clientSubmitButton.click(function () {
      processForm();
    })

    function processForm() {
      const isValid = validateForm();

      if (isValid) {
        submitForm();
      }
    }

    function submitToEmail() {
      var form = $('#prequalification-email-form');
      var formData = form.serialize();
      var url = '/api/prequalification/email';
      $.ajax({
        type: 'POST',
        url: url,
        data: formData,
        success: function (data) {

          // Ajax call completed successfully
          // alert('Form Submited Successfully');

          var search = '?pqguid=' + data.itemGuid;
          window.location.href = window.location.protocol + '//' + window.location.host + window.location.pathname + search;
        },
        error: function (data) {

          // Some error in ajax call
          alert('Error submitting data');
        }
      });
    }

    // Validates the form's input fields and returns whether the form is valid
    // Invalid fields will have validation class applied to them
    function validateForm() {

      let formIsValid = true;

      $inputs.each(function () {
        const $formGroup = $(this).closest('.form-group');

        $formGroup.removeClass('is-invalid');

        if (!this.checkValidity()) {
          formIsValid = false;
          $formGroup.addClass('is-invalid');
        }
      });

      return formIsValid;
    }

    // Submits the form
    function submitForm() {
      // $serverSubmitButton.click();
      submitToEmail();
    }
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  initializePrequalificationEmail()
})

